import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/simples";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullOrEmpty } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { observeResource } from "kea-resource";
import { validarRFC, erroresValidarIdentificacion, erroresValidarIdentificacionNoRepetidos } from "app/logic/cliente";
import { CodigoRegimenFiscal } from "app/models/requireme";

type Entity = models.DatosFacturacionNuevoCliente;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    /**Datos que se le van a pasar al resource que comprueba si estan repetidos los datos */
    readonly?: boolean;
    error?: kea.FieldError;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        CodigoRegimenFiscal: validation.required

    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
class DatosFacturacionComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => this.props.value;

    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    get rules(): validation.Rules<Entity> {
        CodigoRegimenFiscal : validation.required
        return {};
    }
   
    render() { 
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const CodigoRegimenFiscal = getField(selectores.CodigoRegimenFiscal);

         
         return (
            <div> 
                <kea.Panel title="Datos Facturacion" iconClass={fa("id-card-o")} error={this.props.error} style="success" >
                
                {
                        kea.autogrid(6, [
                            <CodigoRegimenFiscal field="CodigoRegimenFiscal" label="Regimen Fiscal " />

                        ])
                }   
                </kea.Panel>
            </div>);
    }
}

export const DatosFacturacionComponent = componentToRx(kea.mapProps(DatosFacturacionComponentNoRx, x => ({ ...x, value: x.value || {} })), <kea.Spinner />, undefined, {
    error: { ignore: { observable: true, promise: true } }
});


// WEBPACK FOOTER //
// ./app/features/componentes/cliente/datosFacturacion.tsx